"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinPriceAndPreview = void 0;
const react_1 = __importDefault(require("react"));
const NumericInput_1 = require("../../input/numeric/NumericInput");
const Spacer_1 = require("../../spacer/Spacer");
const helpers_1 = require("../../../pages/tasks/pricing/helpers");
const fullStory_1 = require("../../../../util/fullStory");
const index_1 = require("../../../../index");
const MinPriceAndPreview = ({ defaults, setDefaults, validation, showValidation, setShowValidation, isBasePriceExperiment, }) => {
    const { propertyId } = react_1.default.useContext(index_1.AppContext);
    react_1.default.useEffect(() => {
        (0, fullStory_1.sendCustomFullStoryEvent)('smart_pricing_min_price_modal_viewed', {
            property_id: propertyId,
        });
    }, []);
    const validateMinimumPrice = (value) => {
        if (value === undefined || value <= (0, helpers_1.toFloyd)(15)) {
            return {
                valid: false,
                message: 'The minimum price per night must be greater than 15.',
                type: 'error',
            };
        }
        if (!isBasePriceExperiment) {
            return {
                valid: true,
                type: 'success',
                message: '',
            };
        }
        if (!defaults.base_price) {
            return {
                valid: false,
                message: 'Please set a base price.',
                type: 'error',
            };
        }
        if (value > defaults.base_price) {
            return {
                valid: false,
                message: 'The minimum price per night must be less than or equal to the base price.',
                type: 'error',
            };
        }
        if (value <= defaults.base_price * 0.5) {
            return {
                valid: true,
                type: 'success',
                message: 'Your minimum price is within the recommended range related to your base price',
            };
        }
        if (value < defaults.base_price * 0.65) {
            return {
                valid: true,
                type: 'warning',
                message: 'Your minimum price could be too high. We recommend lowering it to 50% of your base price',
            };
        }
        return {
            valid: true,
            type: 'error',
            message: 'There is not enough of a gap between your minimum and base price. We recommend your minimum is 50% of your base price',
        };
    };
    const validateBasePrice = (value) => {
        if (value === undefined || value <= (0, helpers_1.toFloyd)(15)) {
            return {
                valid: false,
                message: 'The base price per night must be greater than 15.',
                type: 'error',
            };
        }
        if (isBasePriceExperiment && value < defaults.min_price) {
            return {
                valid: false,
                message: 'The base price per night must be greater than or equal to the minimum price.',
                type: 'error',
            };
        }
        return {
            valid: true,
            message: '',
            type: 'success',
        };
    };
    const basePriceValidation = validateBasePrice(defaults.base_price);
    const minPriceValidation = validateMinimumPrice(defaults.min_price);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isBasePriceExperiment && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(NumericInput_1.NumericInput, { label: "Base price", hintText: "Your base price is your \u201Csweet spot\u201D \u2014 it's the rate you\u2019d expect on a typical booked night.", id: "base-price-input", value: (defaults === null || defaults === void 0 ? void 0 : defaults.base_price) && (0, helpers_1.fromFloyd)(defaults.base_price), handleChange: (value) => {
                    setShowValidation(true);
                    setDefaults(Object.assign(Object.assign({}, defaults), { base_price: (0, helpers_1.toFloyd)(value !== null && value !== void 0 ? value : 0) }));
                }, valid: basePriceValidation.valid, errorMessage: basePriceValidation.message, annotationMessage: basePriceValidation.message, annotationType: basePriceValidation.type }),
            react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }))),
        react_1.default.createElement(NumericInput_1.NumericInput, { label: "Minimum price", hintText: "Your minimum price is the lowest nightly rate you\u2019d accept to avoid leaving your property unbooked.", id: "min-price-input", value: (0, helpers_1.fromFloyd)(defaults.min_price), handleChange: (value) => {
                setShowValidation(true);
                setDefaults(Object.assign(Object.assign({}, defaults), { min_price: (0, helpers_1.toFloyd)(value !== null && value !== void 0 ? value : 0) }));
            }, valid: minPriceValidation.valid, errorMessage: minPriceValidation.message, annotationMessage: minPriceValidation.message, annotationType: minPriceValidation.type })));
};
exports.MinPriceAndPreview = MinPriceAndPreview;
//# sourceMappingURL=MinPriceAndPreview.js.map